// extracted by mini-css-extract-plugin
export default {"rotate":"styles_rotate__Txj5E","loading":"styles_loading__+QvI3"};